<template>
  <v-container>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col class="d-flex justify-end" cols="2">
        <v-switch
          v-model="boolFilter"
          :label="boolFilter == true ? 'Show' : 'Hide'"
          :color="setting.COLOR"
          hide-details
        ></v-switch>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :color="setting.BACKGROUNDCOLOR"
          v-model="strStudyId"
          clear-icon="mdi-close-circle"
          clearable
          label="Study ID"
          type="text"
          outlined
          @keyup.enter="addCompareList(strStudyId)"
        >
          <template v-slot:append-outer>
            <v-icon
              :color="setting.BACKGROUNDCOLOR"
              @click="addCompareList(strStudyId)"
              size="30"
              >mdi-magnify</v-icon
            >
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="mt-lg text-center" v-if="boolLoadData">
          <v-progress-circular
            :size="200"
            :color="setting.COLOR"
            indeterminate
            dark
          >
            Loading, please wait ...</v-progress-circular
          >
        </div>
      </v-col>
    </v-row>
    <template v-if="boolFilter">
      <v-row>
        <v-col cols="4">
          <v-combobox
            v-model="strCompany"
            :items="arrCompany"
            :color="setting.BACKGROUNDCOLOR"
            label="Company ID"
          >
            <template v-slot:selection="{ item }">
              <v-chip class="px-4" :color="setting.BACKGROUNDCOLOR" dark>
                {{ item }}
                <!-- <v-icon
                  class="ml-1"
                  small
                >mdi-close-circle</v-icon>-->
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="4">
          <v-combobox
            v-model="strTA"
            :items="arrTA"
            :color="setting.BACKGROUNDCOLOR"
            label="Therapeutic Areas"
          >
            <template v-slot:selection="{ item }">
              <v-chip class="px-4" :color="setting.BACKGROUNDCOLOR" dark>
                {{ item }}
                <!-- <v-icon
                  class="ml-1"
                  small
                >mdi-close-circle</v-icon>-->
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="2">
          <v-combobox
            v-model="strPhase"
            :items="arrPhase"
            :color="setting.BACKGROUNDCOLOR"
            label="Phase"
          >
            <template v-slot:selection="{ item }">
              <v-chip class="px-4" :color="setting.BACKGROUNDCOLOR" dark>
                {{ item }}
                <!-- <v-icon
                  class="ml-1"
                  small
                >mdi-close-circle</v-icon>-->
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col cols="2">
          <v-btn
            :color="setting.BACKGROUNDCOLOR"
            class="ma-2 white--text"
            block
            @click="filterStudy"
          >
            <v-icon class="mr-3" dark>mdi-cloud-upload</v-icon>Filter Study
          </v-btn>
        </v-col>
      </v-row>
      <v-card class="pt-4 my-2" v-if="arrStudyFields.length">
        <v-row no-gutters>
          <v-col
            v-for="(item, index) in arrStudyFields"
            :key="index"
            cols="12"
            sm="6"
            md="3"
            class="pa-4"
          >
            <v-card max-width="344" outlined>
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">{{ item["NCTId"][0] }}</div>
                  <v-list-item-title class="headline mb-1">{{
                    item["OrgStudyId"][0]
                  }}</v-list-item-title>
                  <!-- <v-list-item-subtitle>{{item["BriefTitle"][0]}}</v-list-item-subtitle> -->
                  {{ item["BriefTitle"][0] }}
                </v-list-item-content>

                <v-list-item-avatar size="80">
                  <span class="white--text headline">{{
                    item["Condition"]
                  }}</span>
                </v-list-item-avatar>
              </v-list-item>
              <v-card-actions>
                <v-spacer></v-spacer>
                <template v-if="item['Select']">
                  <v-btn
                    class="mx-2"
                    dark
                    icon
                    color="#81DEE6"
                    @click="cancleStudy(item)"
                  >
                    <v-icon>mdi-star</v-icon>
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    class="mx-2"
                    dark
                    icon
                    color="#81DEE6"
                    @click="selectStudy(item)"
                  >
                    <v-icon>mdi-star-outline</v-icon>
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </template>
    <v-row>
      <v-col>
        <v-combobox
          color="#81DEE6"
          multiple
          v-model="arrStudy"
          label="Study ID"
          chips
          deletable-chips
        >
          <!-- <template v-slot:selection="{item,parent,index}"> -->
          <template v-slot:selection="{ item, parent }">
            <v-chip class="px-3" color="#81DEE6" dark>
              {{ item }}
              <v-icon
                class="ml-1"
                small
                @click="parent.selectItem(item), removeCompare(item)"
                >mdi-close-circle</v-icon
              >
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <template v-if="jsonMetaProtocol">
      <template v-for="(model, modelKey) in jsonMetaProtocol">
        <v-card class="my-2 text-left" :key="modelKey">
          <v-toolbar :color="setting.COLOR" dark flat>
            <v-card-title class="text-h5">{{
              model.title ? model.title.toUpperCase() : model.name.toUpperCase()
            }}</v-card-title>
          </v-toolbar>
          <v-list>
            <v-list-item>
              <v-avatar> </v-avatar>
              <v-list-item-content>
                <v-col cols="3"></v-col>
                <template v-for="(itemCol, itemColKey) in arrStudy">
                  <v-col :key="`${itemColKey}`">
                    <v-chip
                      class="text-h5 font-weight-bold"
                      :color="arrStudyColor[itemColKey]"
                      large
                      dark
                    >
                      <v-icon left dark> mdi-server-plus </v-icon>
                      {{ itemCol }}
                    </v-chip>
                  </v-col>
                </template>
              </v-list-item-content>
            </v-list-item>
            <template v-for="(item, itemKey) in model.children">
              <v-list-item :key="`${modelKey}-${itemKey}`">
                <v-avatar class="mr-2" :color="setting.COLOR">
                  <v-icon dark> mdi-domain </v-icon>
                </v-avatar>
                <v-list-item-content>
                  <v-card flat>
                    <v-row>
                      <v-col
                        class="text-h6"
                        :style="{ color: setting.COLOR }"
                        cols="3"
                      >
                        {{ item.title || item.piece }}
                      </v-col>
                      <template v-if="item.comparison">
                        <template v-for="(itemCol, itemColKey) in arrStudy">
                          <v-col
                            class="text-subtitle-1"
                            :style="{ color: arrStudyColor[itemColKey] }"
                            :key="`${modelKey}-${itemKey}-${itemColKey}`"
                          >
                            <template v-if="!isUndef(item.comparison[itemCol])">
                              <template
                                v-if="
                                  typeof item.comparison[itemCol] == 'string'
                                "
                              >
                                {{ item.comparison[itemCol] }}
                              </template>
                              <template
                                v-else-if="
                                  typeof item.comparison[itemCol] == 'object'
                                "
                              >
                                <v-card
                                  class="my-1"
                                  v-for="(subItem, subItemKey) in item
                                    .comparison[itemCol]"
                                  :key="`${modelKey}-${itemKey}-${subItemKey}-sub`"
                                >
                                  <v-card-title class="text-subtitle-1">
                                    <v-chip color="green" text-color="white">
                                      {{ subItemKey + 1 }}
                                      <!-- {{ item }} -->
                                    </v-chip>
                                  </v-card-title>
                                  <v-divider></v-divider>
                                  <v-list dense>
                                    <v-list-item
                                      class="text-subtitle-1"
                                      v-for="(value, key) in item.children"
                                      :key="`${modelKey}-${itemKey}-${subItemKey}-sub-${key}`"
                                      link
                                    >
                                      <v-list-item-content>
                                        <div>
                                          <span
                                            :style="{ color: setting.COLOR }"
                                          >
                                            {{ value.title }}</span
                                          >
                                          :
                                          <span>{{
                                            isUndef(subItem[value.name])
                                              ? "-"
                                              : subItem[value.name]
                                          }}</span>
                                        </div>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </template>
                              <template v-else>
                                {{ item.comparison[itemCol] }}
                              </template>
                            </template>

                            <template v-else>
                              <v-icon>mdi-minus</v-icon>
                            </template>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                    <template v-if="item.children && !item.comparison">
                      <template v-for="(subItem, subItemKey) in item.children">
                        <v-row
                          :key="`${modelKey}-${itemKey}-${subItemKey}`"
                          dense
                        >
                          <v-col
                            class="px-5 text-h6"
                            :style="{ color: setting.BACKGROUNDCOLOR }"
                            cols="3"
                          >
                            {{ subItem.title || subItem.piece }}
                          </v-col>
                          <template v-if="subItem.comparison">
                            <template v-for="(itemCol, itemColKey) in arrStudy">
                              <v-col
                                class="text-subtitle-1"
                                :style="{ color: arrStudyColor[itemColKey] }"
                                :key="`${modelKey}-${itemKey}-${subItemKey}-${itemColKey}`"
                              >
                                <template v-if="!isUndef(subItem.comparison[itemCol])">
                                  {{ subItem.comparison[itemCol] }}
                                </template>
                                <template v-else>
                                  <v-icon>mdi-minus</v-icon>
                                </template>
                              </v-col>
                            </template>
                          </template>
                        </v-row>
                        <template v-if="subItem.children">
                          <template
                            v-for="(element, elementKey) in subItem.children"
                          >
                            <v-row
                              :key="`${modelKey}-${itemKey}-${subItemKey}-${elementKey}`"
                              dense
                            >
                              <v-col class="px-6 text-title" cols="3">
                                {{ element.title || element.piece }}
                              </v-col>
                              <template v-if="element.comparison">
                                <template
                                  v-for="(itemCol, itemColKey) in arrStudy"
                                >
                                  <v-col
                                    class="text-subtitle-1"
                                    :style="{
                                      color: arrStudyColor[itemColKey],
                                    }"
                                    :key="`${modelKey}-${itemKey}--${elementKey}-${itemColKey}`"
                                  >
                                    <template
                                      v-if=" !isUndef(element.comparison[itemCol])"
                                    >
                                      {{ element.comparison[itemCol] }}
                                    </template>
                                    <template v-else>
                                      <v-icon>mdi-minus</v-icon>
                                    </template>
                                  </v-col>
                                </template>
                              </template>
                            </v-row>
                          </template>
                        </template>
                      </template>
                    </template>
                  </v-card>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="itemKey < model.children.length - 1"
                :key="`${itemKey}-d`"
                inset
              ></v-divider>
            </template>
          </v-list>
        </v-card>
      </template>
    </template>
  </v-container>
</template>
<style>
.row_style {
  vertical-align: middle;
}
.row_select_first:hover {
  border: 2px solid#81DEE6;
  /* padding: 10px 40px; */
  background: #eaf5f7;
  /* width: 300px; */
  border-radius: 2px;
}
.row_select_second:hover {
  /* border: 2px solid #29aaf5; */
  /* padding: 10px 40px; */
  /* background: #b5dbf1; */
  /* width: 300px; */
  /* border-radius: 5px; */
  /* border: 1px solid #a1a1a1; */
  /* padding: 10px 40px; */
  /* background: #dddddd; */
  /* width: 300px; */
  /* border-radius: 2px; */
  color: #28a759;
}
.row_select_third:hover {
  /* border: 2px solid #29aaf5; */
  /* padding: 10px 40px; */
  /* background: #b5dbf1; */
  /* width: 300px; */
  /* border-radius: 5px; */
  color: #222222;
}
</style>
<script>
import { mapState } from "vuex";
var ctgov = require("@/plugins/ctgov");
var { compareTrial } = require("@/plugins/comptrial");
export default {
  name: "TrialComparer",
  data: () => ({
    boolFilter: true,
    boolLoadData: false,
    objCompared: {},
    jsonMetaStudy: null,
    jsonMetaProtocol: null,
    arrStudyFields: [],
    strStudyId: "EFC14112",
    arrStudy: [],
    arrStudyColor: ["#00BCD4", "#009688", "#4CAF50", "#8BC34A"],
    strCompany: "Sanofi",
    arrCompany: [
      "Roche",
      "Novartis",
      "Pfizer",
      "Merck",
      "Bristol-Myers Squibb",
      "Johnson&Johnson",
      "Sanofi",
      "AbbVie",
      "GlaxoSmith",
      "Takeda",
      "AstraZeneca",
      "Amgen",
      "Gilead Sciences",
      "Eli Lilly",
      "Bayer",
      "Novo Nordisk",
      "Boehringer-ingelheim",
      "Allergan",
      "Asterllas",
      "Biogen",
    ],
    strTA: "Diabetes",
    arrTA: [
      "Acute Kidney Injury",
      "Alzheimer's",
      "Asthma",
      "Breast Cancer",
      "Cardiovascular",
      "CDAD",
      "Colorectal Cancer",
      "COPD",
      "COVID-19",
      "Crohn's Disease",
      "Diabetes",
      "Diabetes - Type 1",
      "Diabetic Kidney Disease",
      "Duchenne Muscular Dystrophy",
      "Dyslipidemia",
      "Ebola",
      "Heart Failure",
      "Hepatitis C",
      "HIV",
      "Huntington's Disease",
      "Influenza",
      "Kidney Transplant",
      "Lung Cancer",
      "Major Depressive Disorder",
      "Malaria",
      "Multiple Sclerosis",
      "Nutrition",
      "Pain",
      "Pancreatic Cancer",
      "Parkinson's Disease",
      "Polycystic Kidney Disease",
      "Post Traumatic Stress Disorder",
      "Prostate Cancer",
      "Psoriasis",
      "QT Studies",
      "Rheumatoid Arthritis",
      "Schizophrenia",
      "Traditional Chinese Medicine - Acupuncture",
      "Traditional Chinese Medicine - Coronary Artery Disease-Angina",
      "Traumatic Brain Injury",
      "Tuberculosis",
      "Vaccines",
      "Virology",
    ],
    strPhase: "Phase 1",
    arrPhase: ["Phase 0", "Phase 1", "Phase 2", "Phase 3", "Phase 4"],
    arrDefaultColor: [
      "#03A9F4",
      "#E65100",
      "#6A1B9A",
      "#FFD835",
      "#7CB342",
      "#D81B60",
      "#01579B",
      "#FFB300",
      "#43A047",
      "#E53935",
    ],
    arrDefaultColorLight: [
      "#E1F5FE",
      "#FBE9E7",
      "#6A1B9A",
      "#FFD835",
      "#7CB342",
      "#D81B60",
      "#01579B",
      "#FFB300",
      "#43A047",
      "#E53935",
    ],
    intIndex: -1,
  }),
  created() {},
  mounted() {
    this.initialize();
  },
  watch: {
    strStudyId(val) {
      // console.log(val);
      if (val) {
        this.strStudyId = val.toUpperCase();
      }
    },
  },
  methods: {
    initialize() {
      // console.log(this.strFileName);
      // this.bolLoading = true;

      // let strFileName = process.env.BASE_URL + "/library/metadata.json";
      let strFileName = "./library/metadata_v2.json";
      if (strFileName.length > 0) {
        fetch(strFileName)
          .then((res) => res.json())
          .then((res) => {
            this.jsonMetaStudy = res;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.bolLoading = false));
      }
    },
    addCompareList(val) {
      if (val) {
        // console.log(val);
        this.boolLoadData = true;
        let objProtocol = ctgov.getStudyInfo(val);
        objProtocol
          .then((res) => res)
          .then((res) => {
            // console.log(res);
            if (typeof res !== "undefined") {
              let strStudyId = val;
              this.arrStudy.push(strStudyId);
              // let obj = compareTrial(strStudyId, this.jsonMetaStudy, res);
              this.jsonMetaStudy = compareTrial(
                strStudyId,
                this.jsonMetaStudy,
                res
              );
              console.log(this.jsonMetaStudy);
              if (this.jsonMetaStudy) {
                for (let i = 0; i < this.jsonMetaStudy.length; i++) {
                  let item = this.jsonMetaStudy[i];
                  if (item.name === "protocolSection") {
                    this.jsonMetaProtocol = item.children;
                    break;
                  }
                }
              }
              val = "";
            }
          })
          .finally(() => {
            this.boolLoadData = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    filterStudy() {
      let strExpr = [this.strCompany, this.strTA, this.strPhase].join(",");
      let strFilter = "NCTId,OrgStudyId,BriefTitle,Condition";
      let objStudyFields = ctgov.getStudyFields(strExpr, strFilter);
      objStudyFields
        .then((res) => res)
        .then((res) => {
          if (typeof res !== "undefined") {
            this.arrStudyFields = res["StudyFields"];
            //  console.log(res);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectStudy(val) {
      val["Select"] = true;
      let strStudyId = val["OrgStudyId"][0];
      this.addCompareList(strStudyId);
    },
    cancleStudy(val) {
      val["Select"] = false;
      let strStudyId = val["OrgStudyId"][0];
      this.arrStudy = this.arrStudy.filter((item) => {
        return item != strStudyId;
      });
    },
    addCompareList1() {
      if (this.strStudyId.length > 0) {
        let objProtocol = ctgov.getStudyInfo(this.strStudyId);
        objProtocol
          .then((res) => res)
          .then((res) => {
            if (typeof res !== "undefined") {
              console.log("1");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    removeCompare() {
      this.arrStudyFields.map((item) => {
        let strStudyId = item["OrgStudyId"][0];
        if (this.arrStudy.indexOf(strStudyId) > -1) {
          item["Select"] = true;
        } else {
          item["Select"] = false;
        }
        return item;
      });
    },
    standardizeName(val, type) {
      let strStdVal = "";
      if (val == "NCTId") {
        strStdVal = "NCT ID";
      } else {
        strStdVal = val
          .split(/(?=[A-Z])/)
          .map((item) => {
            if (item.toUpperCase() == "ID") {
              item = "ID";
            } else if (item.toUpperCase() == "INFO") {
              item = "Information";
            } else if (item.toUpperCase() == "ORG") {
              item = "Organization";
            } else if (item.toUpperCase() == "STD") {
              item = "Standard";
            }
            return item;
          })
          .join(" ");
      }
      if (type == "upper") {
        strStdVal = strStdVal.toUpperCase();
      }
      return strStdVal;
    },
    removeCompare1(val) {
      // console.log(this.objCompared);
      // console.log(val);

      for (let key in this.objCompared) {
        //     this.objCompared[];
        let item = this.objCompared[key];

        for (let subKey in item) {
          if (subKey != "OPTION") {
            let subItem = item[subKey];
            subItem = subItem.splice(val, 1);
          }
        }
      }
      // this.arrStudy = this.arrStudy.map(item => {
      //   item = item.splice(val, 1);
      //   return item;
      // });
    },
    getColor(val) {
      return this.arrDefaultColor[val % this.arrDefaultColor.length];
    },
    getColorLight(val) {
      return this.arrDefaultColorLight[val % this.arrDefaultColorLight.length];
    },
    prettyIdentification() {},
    isUndef(v) {
      return v === undefined || v === null;
    },
  },
  computed: mapState({
    setting: "setting",
  }),
};
</script>
